import {
  asyncRoutes,
  constantRoutes
} from '@/router'
import {
  leftList
} from '@/api/user'
import Layout from '@/layout'
import home from '@/views/home/index.vue'
import vip_config from '@/views/vip_config/index.vue'
/**
 * 使用meta.role确定当前用户是否具有权限
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  // 判断路由规则中是否包含meta，是否包含roles
  if (route.meta && route.meta.roles) {
    // 判断roles例如：admin有没有在meta.roles里面，如果在就返回true，否则就返回false
    return roles.some((role) => route.meta.roles.includes(role))
  } else {
    // 表示有权限访问
    return true
  }
}

/**
 * 通过递归筛选异步路由表
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = []
  routes.forEach((route) => {
    // 循环遍历动态的路由规则，然后存储在tmp里面  roles是用户角色例如：admin
    const tmp = {
      ...route
    }
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })
  return res
}

const state = {
  routes: [], // 静态+当前用户可访问的动态路由
  addRoutes: [] // 当前用户可访问的动态路由
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  }
}

const actions = {
  // 左侧列表
  leftList({
    commit
  }, roles) {
    //
    return new Promise((resolve, reject) => {
      leftList()
        .then((response) => {
          let routerArr = []
          routerArr = response.data.data
          const arr = []
          let redirect = ''
          routerArr.map((item) => {
            // console.log(item);

            if (item.children.length > 0) {
              redirect = '/' + item.pathUrl + '/' + item.children[0].pathUrl
            }
            const obj2 = {
              path: '/' + item.pathUrl,
              component: Layout,
              redirect,
              meta: {
                title: item.name
              },
              name: item.code,
              children: item.children || []
            }
            obj2.children.map((item1) => {
              item1.path = '/' + item.pathUrl + '/' + item1.pathUrl
              item1.children = item1.children
              item1.component = async() => await require('@/views' + item1.path + '.vue')
              item1.meta = {
                title: item1.name
              }
              item1.name = item1.code
            })
            if (item.pathUrl == 'home') {
              obj2.path = '/'
              obj2.redirect = '/' + item.pathUrl
              obj2.children = [{ path: '/home', component: home, name: item.pathUrl, meta: { title: '首页', icon: 'dashboard', affix: true }}]
            }
            if (item.pathUrl == 'vip_config') {
              obj2.path = '/vip_config'
              obj2.redirect = '/' + item.pathUrl
              obj2.children = [{ path: '/vip_config', component: vip_config, name: item.pathUrl, meta: { title: 'vip配置', icon: 'dashboard', affix: true }}]
            }
            arr.push(obj2)
          })
          const arr2 = JSON.parse(JSON.stringify(arr))
          // console.log(arr2);
          commit('SET_ROUTES', arr2)
          resolve(arr)
        })
        .catch((error) => {
          reject(error)
        })
    }).catch((error) => {
      // console.log(error);
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
